import Vouchers from "./routes/Vouchers";
import Announcement from "./routes/Announcement/Announcement.vue";
import HomepageBuyer from "./routes/HomepageBuyer/HomepageBuyer.vue";
import ContentText from "./routes/ContentText";
import ContentTextForm from "./routes/ContentText/ContentTextForm.vue";
import PromoList from "./routes/PromoList/PromoList.vue";
import Banners from "./routes/Banners/Banners.vue";
import FormBanners from "./routes/Banners/Form.vue";


const marketingRoutes = [
  {
    path: "homepage-buyer",
    name: "HomepageBuyer",
    component: HomepageBuyer,
  },
  {
    path: "vouchers",
    name: "Vouchers",
    component: Vouchers,
  },
  {
    path: "promo-list",
    name: "PromoList",
    component: PromoList,
  },
  {
    path: "announcement",
    name: "Announcement",
    component: Announcement,
  },
  {
    path: "banners",
    name: "Banners",
    component: Banners,
  },
  {
    path: "banners/add-new",
    name: "Add-Banners",
    component: FormBanners,
  },
  {
    path: "banners/edit/:id",
    name: "Edit-Banners",
    component: FormBanners,
  },
  {
    path: "content-text",
    name: "ContentText",
    component: ContentText,
  },
  {
    path: "content-text/add",
    name: "ContentTextForm",
    component: ContentTextForm,
  },
  {
    path: "content-text/:id",
    name: "ContentTextForm",
    component: ContentTextForm,
  },
];

export default marketingRoutes;
